import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import authenticationService from '@/core/services/account/authentication.service';
import router from '@/router/router';
import teamsService from '@/core/services/teams/teams.service';
import taskTypesService from '@/core/services/tasktypes/taskTypes.service';
import Spinner from '@/components/Spinner.vue';
import { AuthenticateRequest } from '@/_typedef/missile';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const loading = ref(false);
const errorMessages = ref<string[] | null>();
const model = ref<AuthenticateRequest>({ userName: '', password: '' });

async function authenticate() {
    loading.value = true;

    try {
        await authenticationService.authenticate(model.value);

        await teamsService.getAll();
        await taskTypesService.getAll();

        loading.value = false;
        router.push('/');
    } catch (errors: any) {
        loading.value = false;
        errorMessages.value = errors;
    }
}

return { __sfc: true,loading, errorMessages, model, authenticate, Spinner }
}

})